import { useEffect, useMemo } from "react";
import { useWidget } from "../providers/widget";
import { getAssetUrl } from "../common/utils";

export default function WebFont({ icoFont, extraFamily }: {
    icoFont?: boolean;
    /**
     * An additional Google-hosted family to load alongside the main widget
     * font (#1219 — e.g. the explorer card-skin's title preset). Skipped
     * when falsy or when it's the same family as options.font.family, so a
     * preset that happens to match the widget font never double-requests it.
     */
    extraFamily?: string | null;
}) {
    const { options } = useWidget()
    const loaderOptions = useMemo(() => {
        const families = [options.font.family + ':400,500,600,700&display=swap']
        if (extraFamily && extraFamily !== options.font.family) {
            families.push(extraFamily + ':400,500,600,700&display=swap')
        }
        const ops: WebFont.Config = {
            google: {
                // display=swap rides in the family string (webfontloader has no
                // display option) — keeps this loader consistent with the
                // getFontCssUrl links so text never FOIT-blanks (#787).
                families
            },
            active: () => {
                // console.log('webfontloader active')
            }
        }
        if (icoFont) {
            ops.custom = {
                families: ['icomoon'],
                urls: [getAssetUrl("icomoon/icomoon.css")],
            }
        }
        return ops;
    }, [options.font.family, icoFont, extraFamily])


    useEffect(() => {
        import('webfontloader').then(({ load }) => {
            // console.log('loading webfontloader', icoFont)
            load(loaderOptions)
        })
    }, [options.font.family, extraFamily, loaderOptions])
    return null
}
